import { PickupState } from './pickup.state';
import { emptyCard } from '../../constants/empty-card';
import { Action, createReducer, on } from '@ngrx/store';
import {
    pickupCancelFailure,
    pickupCancelRequest, pickupCancelSuccess,
    pickupReset, pickupSelectCloseTime,
    pickupSelectCourier,
    pickupSelectDate,
    pickupSelectReadyTime,
    pickupSelectShipments,
    pickupSetAvailability, pickupSetParameter, pickupSetSelection, pickupSubmitFailure, pickupSubmitRequest, pickupSubmitSuccess
} from './pickup.actions';
import { upsert } from '../../utils/array-reducer';
import { PickupParameter } from '../../models/pickup-parameter';
import { Parameter } from '../../models/parameter';

const initialState: PickupState = {
    pickupBookingType: null,
    courierModule: null,
    courierCode: null,
    shipmentSelection: [],
    address: emptyCard,
    date: null,
    readyTime: null,
    closeTime: null,
    windows: [],
    minimumWindowMinutes: 120,
    pickupReference: null,
    busy: false,
    availability: [],
    success: null,
    messages: [],
    pickupParameters: [],
    pickupSelection: []
};

const reducer = createReducer(
    initialState,
    on(pickupReset, () => (
        { ...initialState }
    )),
    on(pickupSelectCourier, (state, { courierModule }) => (
        { ...initialState, courierModule, busy: true }
    )),
    on(pickupSelectShipments, (state, { shipmentSelection }) => (
        { ...initialState, shipmentSelection, busy: true }
    )),
    on(pickupSetAvailability, (state, { availability }) => (
        { ...state, courierModule: availability.length > 0 ? availability[0].courierModule : null, availability, busy: false }
    )),
    on(pickupSelectDate, (state, { date }) => (
        { ...state, date }
    )),
    on(pickupSelectReadyTime, (state, { readyTime }) => (
        { ...state, readyTime }
    )),
    on(pickupSelectCloseTime, (state, { closeTime }) => (
        { ...state, closeTime }
    )),
    on(pickupSetParameter, (state, { name, value }) => (
        { ...state, pickupParameters: upsert<Parameter>(state.pickupParameters, { name, value }, 'name' )}
    )),
    on(pickupSubmitRequest, (state) => (
        { ...state, success: null, messages: [], busy: true }
    )),
    on(pickupSubmitSuccess, (state) => (
        { ...state, success: true, busy: false }
    )),
    on(pickupSubmitFailure, (state, { messages }) => (
        { ...state, success: false, messages, busy: false }
    )),
    on(pickupSetSelection, (state, { selection }) => (
        { ...state, pickupSelection: selection }
    )),
    on(pickupCancelRequest, (state) => (
        { ...state, success: null, message: [], busy: true }
    )),
    on(pickupCancelSuccess, (state) => (
        { ...state, success: true, busy: false }
    )),
    on(pickupCancelFailure, (state, { messages }) => (
        { ...state, success: false, messages, busy: false }
    ))
);

export function pickupReducer(state: PickupState | undefined, action: Action): any {
    return reducer(state, action);
}
